import styled from "styled-components/macro";
import { TextField } from "@mui/material";

export const FormGroup = styled.div`
  // margin-bottom: ${(props) => props.mb};
`;

export const TextInput = styled(TextField)`
  display: block !important;
  /* padding: 0.375rem 0.75rem !important; */
  font-size: 1rem;
  line-height: 1.5;
  color: ${(props) => props.textcolor};
  background: ${(props) => props.bg};
  background-clip: padding-box;
  /* border: 1px solid #eaeaea; */
  /* border: ${(props) => props.border}; */
  // border-radius: 6px !important;
  margin-bottom: ${(props) => props.mb};
  width: ${(props) => (props.wx ? props.wx : "100%")};
  
  .MuiInput-underline:before {
    border-bottom: none !important;
  }
  .MuiInput-underline:after {
    border-bottom: none !important;
  }
  .MuiInputBase-root {
    width: 100%;
  }
  .MuiInputBase-root {
    // font-weight: 500 !important;
  }
  .MuiInput-underline {
    &:before {
      position: relative !important;
    }
  }
  /*.MuiInputBase-root-MuiOutlinedInput-root{
    color: unset;
  } */
  .MuiOutlinedInput-notchedOutline{
    border:${(props) => (props.border ? props.border : "unset")};
  }

  .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{
    color: ${(props) => props.textcolor};
    // font-weight: 500;
    border-radius: 10px !important;
  }
  .css-1sqnrkk-MuiInputBase-input-MuiOutlinedInput-input{
    color: ${(props) => props.textcolor};
    // font-weight: 500;
    border-radius: 10px !important;
  }
`;
